import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {UserIdService} from '@spartacus/core';
import {CartActions, MultiCartService, StateWithMultiCart} from "@spartacus/cart/base/core";
import { GonvarriCartAddEntry } from '../actions/gonvarri-cart-add-entry.action';

@Injectable({
  providedIn: 'root'
})
export class GonvarriMultiCartService extends MultiCartService {
  constructor(
    store: Store<StateWithMultiCart>,
    userIdService: UserIdService
  ) {
    super(store, userIdService)
  }

  gonvarriAddEntry(
    userId: string,
    cartId: string,
    productCode: string,
    quantity: number,
    numberOfSheets: number,
    packageWeight: number,
    isContract: boolean,
    pickupStore?: string,
    length?: number
  ): void {
    this.store.dispatch(
      new GonvarriCartAddEntry({
        userId,
        cartId,
        productCode,
        quantity,
        numberOfSheets,
        packageWeight,
        isContract,
        pickupStore,
        length
      })
    );
  }

}
